// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-055d58f5] .v-toolbar__extension{display:block}.filter-button[data-v-055d58f5]{right:64px}[data-v-055d58f5] .archive-disabled,[data-v-055d58f5] .archive-disabled *{cursor:not-allowed!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
